(function ($) {
  var section = $('.cards-with-icons.with-filter');
  if (section.length > 0) {
    var items = $('.cards-with-icons.with-filter .col-three');

    function filter(filter_items_arr) {
      var product_term = filter_items_arr[0].toLowerCase();

      var queryParams = new URLSearchParams(window.location.search);
      if(product_term =="all_product"){
        queryParams.delete("product");
        history.replaceState(null, null, "/solutions/");
      }else{
        queryParams.set("product", product_term);
        history.replaceState(null, null, "/solutions/?"+queryParams.toString());
      }
      
      $('.cards-with-icons.with-filter .col-three').addClass('hide').removeClass('show filtered');
      $('.cards-with-icons.with-filter .col-three[data-product*="' + product_term + '"]').removeClass('hide filter-hide').addClass('show filtered');
      var itemLength = items.length;
      var hiddenitemLength = $('.cards-with-icons.with-filter .col-three.hide').length;
      if (hiddenitemLength >= itemLength) {
        $('.cards-with-icons.with-filter .no-result').show();
        $('.cards-with-icons.with-filter .no-result h3').text("No Result Found");
      } else {
        $('.cards-with-icons.with-filter .no-result').hide();
        $('.cards-with-icons.with-filter .no-result h3').text("");
      }
    }

    $(window).on("load", function () {
      var filter_items = ["all_product"];

      let params = new URL(document.location).searchParams;
      if (params.size > 0) {
        let product_name = params.get("product")
        let pro_type = $('.filter-wrap .filter .selector-wrap.team .option-wrap li')

        let pro_found = datalist('.filter-wrap .filter .selector-wrap.team .option-wrap li').findIndex((element) => element == product_name)

        if (product_name && pro_found >=0 ) {
          filter_items[0] = product_name
          pro_type.parent().parent().find('span').text(capitalize(product_name))
        }

        smoothScrollTo($(".filter-wrap .filter .selector-wrap.team"));
      }

      //Filter By Product
      $('.filter-wrap .filter .selector-wrap.team .option-wrap li').on('click', function () {
        var data_text = $(this).attr("data-id");
        var text = $(this).text();
        $(this).parent().parent().find('span').text(text);
        filter_items[0] = data_text;
        filter(filter_items);
      });


      filter(filter_items);
    });

    function smoothScrollTo($offset) {
      if ($offset.length) {
        $('html, body').animate({scrollTop: $offset.offset().top - 90,}, 700, 'linear');
      }
    }

    $('.filter-wrap .filter .selector-wrap .option-wrap li').on('click', function () {
      $(this).parent().parent().parent().find('.selector-wrap').removeClass("active");
    });
  }


})(jQuery);